var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","loading":_vm.loading,"disabled":_vm.loading}},[(!_vm.renderAsImg)?_c('div',{staticStyle:{"width":"100%","height":"calc(99vh - 50px)"},attrs:{"id":"pdfContainer"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }